import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { StorageService, StorageType, TranslationService } from 'gast-common-ng';
import { ClozeTestModel } from 'gast-onset-ng/lib/cloze-test/model/cloze-test-model';
import { ClozeTestStyleModel } from 'gast-onset-ng/lib/cloze-test/model/cloze-test-style-model';
import { UrlParametersModel } from 'gast-onset-ng/lib/cloze-test/model/url-parameters-model';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Subscription } from 'rxjs';
import { BookingMappingDto } from 'src/shared/dtos/booking-mapping-dto';
import { BookingDto } from 'src/shared/dtos/booking/booking-dto';
import { StorageKeys } from 'src/shared/services/constants/storage-keys';
import { OnsetService } from 'src/shared/services/onset-service';

@Component({
  selector: 'app-onset-study',
  templateUrl: './onset-study.component.html',
  styleUrls: ['./onset-study.component.css']
})
export class OnsetStudyComponent implements OnInit {
  mobileMode: boolean;
  environment;

  lang = 'DE';

  subscription = new Subscription();

  cTestLogo: string;
  clozeTestModel: ClozeTestModel;
  clozeTestStyleModel: ClozeTestStyleModel;

  currentBooking: BookingDto;

  username: string;
  enoughMobileParticipant = false; // 100 is cut off
  cTestButtonColor: string;

  bookingLoaded = false;
  participantsCounted = false;
  onsetStarted = false;

  startLevel = 2;
  endLevel = 4;
  mobileVariantId = 13;
  desktopVariantId = 14;
  language = 1;

  bookingMappings: Array<BookingMappingDto> = []
  mobileCtestDone = false;
  desktopCtestDone = false;

  frontEndLanguage = 1;

  displayStatus = '';

  showCustomButton = true;
  customButtonIcon = 'assets/Notizblock.png';
  customButtonIconHeight = '60px';
  customButtonText = ' Zum Fragebogen';

  deLevelText = 'Das Testergebnis erlaubt eine Einstufung analog zur globalen Skala des Gemeinsamen europäischen Referenzrahmens bis maximal B2 oder höher. Die Einstufung lautet:';
  enLevelText = 'The test result allows a classification according to the global scale of the Common European Framework of Reference up to B2 or higher. The classification is:';
  customResultLevelText = this.deLevelText;

  showIntroduction = true;
  canGoToSurveyDesktop = false;
  canGoToSurveyMobile = false;

  constructor(
    @Inject('env') private envConfig: any,
    private deviceService: DeviceDetectorService,
    private onsetService: OnsetService,
    private storageService: StorageService,
    public translationService: TranslateService,
    public translateService: TranslationService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.environment = this.envConfig.callback(this.envConfig.value);
    // detect mobile
    this.mobileMode = this.deviceService.isMobile();

    // handle language
    this.route.queryParams.subscribe(params => {
      if (params.lang) {
        const lang = params.lang.toLocaleLowerCase();
        this.lang = lang.toLocaleUpperCase();
        this.changeLanguage(lang);
      }
    });

    // this.mobileMode = true;
    this.clozeTestStyleModel = this.generateClozeTestStyle();
    this.cTestButtonColor = this.clozeTestStyleModel.onsetColor;
    // sett logo and button color
    this.cTestLogo = 'onset-assets/img/onset_logo.png';
    // get username from storage
    if (this.storageService.getItem(StorageKeys.USER, StorageType.Local)) {
      this.username = this.storageService.getItem(StorageKeys.USER, StorageType.Local).username;
    }

    this.subscription.add(this.onsetService.bookingMappingSaved.subscribe((bookingMappings: Array<BookingMappingDto>) => {
      this.bookingMappings = bookingMappings;
      // set status for each onset type
      this.bookingMappings.forEach(bm => {
        if (bm.onsetType == 'DESKTOP' && bm.bookingStatus && bm.bookingStatus == 'COMPLETED') {
          this.desktopCtestDone = true;
          this.canGoToSurveyDesktop = true;
        }
        if (bm.onsetType == 'MOBILE' && bm.bookingStatus && bm.bookingStatus == 'COMPLETED') {
          this.mobileCtestDone = true;
          this.canGoToSurveyMobile = true;
        }
      });
      this.bookingLoaded = true;
      this.onsetService.checkIfEnoughMobileParticipantForOnsetStudy();
    }));

    this.subscription.add(this.onsetService.bookingStudyLoaded.subscribe((bookingDto: BookingDto) => {
      this.currentBooking = bookingDto;
      // get or create onset booking mapping (onsetDb)
      // get or create onset booking (onsetDb)
      this.onsetService.createBookingMappingForBooking(bookingDto, this.username);
    }));

    this.subscription.add(this.onsetService.checkIfEnoughMobileParticipantDone.subscribe((enoughParticipant: boolean) => {
      this.enoughMobileParticipant = enoughParticipant;
      this.participantsCounted = true;
      // determine what to display
      if (this.mobileCtestDone && this.desktopCtestDone && this.mobileMode) {
        this.displayStatus = 'SHOW_MOBILE';
      } else if (this.mobileCtestDone && this.desktopCtestDone && !this.mobileMode) {
        this.displayStatus = 'SHOW_DESKTOP';
      } else if ((!this.enoughMobileParticipant || this.desktopCtestDone) && !this.mobileMode && !this.mobileCtestDone) {
        this.displayStatus = 'SHOW_MOBILE_WARNING';
      } else if ((!this.enoughMobileParticipant || this.desktopCtestDone) && this.mobileMode && !this.mobileCtestDone) {
        this.displayStatus = 'SHOW_MOBILE';
      } else if ((this.enoughMobileParticipant || this.mobileCtestDone) && this.mobileMode && !this.desktopCtestDone) {
        this.displayStatus = 'SHOW_DESKTOP_WARNING';
      } else if ((this.enoughMobileParticipant || this.mobileCtestDone) && !this.mobileMode && !this.desktopCtestDone) {
        this.displayStatus = 'SHOW_DESKTOP';
      }
    }));

    this.subscription.add(this.translationService.onLangChange.subscribe((l) => {
      switch (l.lang) {
        case 'de':
          this.customResultLevelText = this.deLevelText;
          break;
        case 'en':
          this.customResultLevelText = this.enLevelText;
          break;
        default:
          this.customResultLevelText = this.deLevelText;
          break;
      }

      if (l.lang.toLocaleUpperCase() == 'de') {
        this.frontEndLanguage = 1;
      } else {
        this.frontEndLanguage = 2
      }
    }));

    // get current onset-booking-study (bookingDb) or create new if not exist
    this.onsetService.createOnsetBookingStudy();
  }

  changeLanguage(lang: string) {
    this.translateService.changeLanguageUsingCode(lang);
    if (lang.toLocaleUpperCase() == 'DE') {
      this.frontEndLanguage = 1;
    } else {
      this.frontEndLanguage = 2
    }

    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams: { lang: lang.toLocaleLowerCase() },
        queryParamsHandling: 'merge'
      });
  }

  public startMobileOnset(): void {
    const bookingMapping = this.bookingMappings.filter(bm => bm.onsetType == 'MOBILE')[0];
    this.clozeTestModel = this.generateClozeTestModel(bookingMapping.bookingId);
    this.onsetStarted = true;
  }

  public startDesktopOnset(): void {
    const bookingMapping = this.bookingMappings.filter(bm => bm.onsetType == 'DESKTOP')[0];
    this.clozeTestModel = this.generateClozeTestModel(bookingMapping.bookingId);
    this.onsetStarted = true;
  }

  public updatedCustomButtonText(): void {
    if (this.lang === 'DE') {
      this.customButtonText = ' Zum Fragebogen';
    } else {
      this.customButtonText = ' To the questionnaire';
    }
  }

  public onStartTest(start: boolean): void {
    console.log(`test started`);
  }

  public onBookingInit(gastBookingId: number): void {
    console.log(`init gastBookingId ${gastBookingId}`);
  }

  public onTestHasBeenSaved(gastBookingId: number): void {
    console.log(`saving gastBookingId ${gastBookingId}`);
  }

  public onClozeTestCompleted(): void {
    console.log(`test completed`);
  }

  public onTestResult(test: any): void {
    console.log(`test result ${test}`);
  }

  public toLimeSurvey(): void {
    const os = this.deviceService.os_version;
    const browser = this.deviceService.browser;
    const device = this.deviceService.device;
    const width = window.screen.width;
    const height = window.screen.height;
    const resolution = `${width.toString()}x${height.toString()}`;
    const url = `https://umfragen.gast.de/index.php/664968?C1=${device}&C2=${os}&C3=${browser}&C4=${resolution}`;
    window.open(url, "_blank");
  }

  public onGerInfoClicked(): void {
    let lang = 'de';
    if (this.frontEndLanguage == 2) {
      lang = 'en'
    }
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/ger-info'], { queryParams: { lang: lang } })
    );
    window.open(url, '_blank');
  }

  private generateClozeTestModel(gastBookingId: number): ClozeTestModel {
    const onsetServiceUrl = this.environment.onsetServiceUrl;
    // const onsetServiceUrl = 'http://gast-appr-app-2:8008/gast-service-onset/';
    // const onsetServiceUrl = 'https://apprex.gast.de/gast-service-onset/';

    let variantId = 13;
    if (!this.mobileMode) {
      variantId = 14;
    }

    // TODO config
    const clozeTestModel: ClozeTestModel = {} as ClozeTestModel;
    clozeTestModel.getResultsUrl = onsetServiceUrl + 'api/score';
    clozeTestModel.postTestUrl = onsetServiceUrl + 'api/aufgabe/save';
    clozeTestModel.getTestUrl = onsetServiceUrl + 'api/aufgabe';
    clozeTestModel.getNextTestUrl = onsetServiceUrl + 'api/aufgabe/next';
    clozeTestModel.startWithBuchungId = gastBookingId;
    clozeTestModel.onsetServiceUrl = onsetServiceUrl;
    clozeTestModel.frontEndLanguageId = this.frontEndLanguage;
    clozeTestModel.urlParameters = {
      herkunft: 'deutschland',
      geschlecht: 'm',
      geburtsdatum: '1990-01-01',
      variante: variantId,
      testzentrum: 454,
      sprache: this.language,
      tool: 1,
      start_level: this.startLevel,
      end_level: this.endLevel
    } as UrlParametersModel;
    return clozeTestModel;
  }

  private generateClozeTestStyle(): ClozeTestStyleModel {
    // TODO config
    const model = {} as ClozeTestStyleModel;
    model.siteBackground = '#ffffff';
    model.exerciseBackground = '#EEF3F8';
    model.frameColor = '#92aac1';
    model.barColor = '#b3c9de';
    model.specialCharacterListColor = '#b3c9de';
    model.specialChcaracterTextColor = '#000000';
    model.exerciseTextColor = '#000000';
    model.buttonsColor = '#fa9463';
    model.testdafColor = '#57a7d6';
    model.onsetColor = '#a5d8db';
    model.duoColor = '#ed6a5b';
    model.testasColor = '#fac075';
    model.font = 'arial, helvetica, sans-serif';
    model.fontSize = '11pt';
    model.displayLogo = true;
    model.cTestInformationUrl = 'https://www.onset.de/onset/durchfuehrung/zusatz.jsp';
    return model;
  }
}
